module.exports = __webpack_public_path__ + "static/img/datachuli2.5e0abbb7.png";